import '@angular/compiler';
import { LayoutSajuComponent } from './layout.saju/layout.saju.component';
import { PageSajuComponent } from './page.saju/page.saju.component';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
    declarations: [
        AppComponent,
        LayoutSajuComponent,
        PageSajuComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }
